import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ERR_MAP = {
  github_denied: 'GitHub sign-in was cancelled.',
  github_not_configured: 'GitHub OAuth is not configured on this server.',
  github_token_failed: 'Failed to get GitHub access token.',
  github_failed: 'GitHub authentication failed.',
};

export default function OAuthCallback() {
  const [params] = useSearchParams();
  const { handleOAuthToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('accessToken');
    const err = params.get('error');

    if (err) { setError(ERR_MAP[err] || `Sign-in error: ${err}`); return; }
    if (!token) { navigate('/login', { replace: true }); return; }

    window.history.replaceState({}, '', '/oauth/callback');

    handleOAuthToken(token)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch(() => navigate('/login?error=oauth_failed', { replace: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div className="card" style={{ maxWidth: 360, width: '100%', padding: 32, textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 16, color: 'var(--danger)' }}>!</div>
        <p style={{ color: 'var(--text-2)', marginBottom: 20 }}>{error}</p>
        <button onClick={() => navigate('/login', { replace: true })} className="btn-primary" style={{ width: '100%', padding: 11 }}>
          Back to sign in
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
      <div style={{
        width: 36, height: 36, borderRadius: '50%',
        border: '3px solid var(--border)', borderTopColor: 'var(--accent)',
        animation: 'spin 0.7s linear infinite',
      }} />
      <p style={{ fontSize: 14, color: 'var(--text-2)' }}>Signing you in…</p>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
